export default function (elementId, offset = 64) {
    const topOffset = -offset;
    const element = document.getElementById(elementId);
    const top = element.getBoundingClientRect().top;
    const y = top + window.scrollY + topOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
}
